import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

import {
  TrialAccountRequest,
  TrialAccountRequestStatus,
} from '../../state/models';

@Component({
  selector: 'app-trial-accounts-list',
  templateUrl: './trial-accounts-list.component.html',
  styleUrls: ['./trial-accounts-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrialAccountsListComponent {
  @Input() trialAccountsRequests: TrialAccountRequest[];
  @Input() isLoading: boolean;
  @Input() hasTrialDispenserRole: boolean;
  @Input() selectedRequestId: string;
  @Output() approve = new EventEmitter<TrialAccountRequest>();
  @Output() decline = new EventEmitter<TrialAccountRequest>();

  public TrialAccountRequestStatus = TrialAccountRequestStatus;

  public trackByTrialFn(_: number, { id }: TrialAccountRequest) {
    return id;
  }

  public toggleApproveConfirmationPopup(
    popover: NgbPopover,
    request: TrialAccountRequest,
  ) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open({ popover, request });
    }
  }

  public toggleDeclineConfirmationPopup(
    popover: NgbPopover,
    request: TrialAccountRequest,
  ) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open({ popover, request });
    }
  }
}
